import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'customerEmailFilter',
    standalone: false
})
export class SearchPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!args) {
      return value;
    }
    return value.filter((val) => {
        console.log(val)
      let rVal = (val.clientName.toLocaleLowerCase().includes(args)) || (val.email.toLocaleLowerCase().includes(args));
      console.log(rVal);
      return rVal;
    })

  }

}